'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdr';
var iconName = 'badge-check';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f336';
var svgPathData = ['M48 256l.2 4.5c1.6 22.2 14.7 41.2 33.4 51.2l17.5 9.3-5.8 19c-6.7 21.7-1.4 46.1 15.6 63.2 17 17 41.4 22.3 63.1 15.6l19-5.8 9.3 17.6c10.6 20 31.6 33.6 55.7 33.6 24.1 0 45-13.5 55.7-33.6l9.3-17.6 19 5.8c21.7 6.7 46.1 1.4 63.2-15.6s22.3-41.5 15.6-63.2l-5.8-19 17.6-9.3c20-10.6 33.6-31.6 33.6-55.7 0-24.1-13.6-45.1-33.6-55.7l-17.6-9.3 5.8-19c6.7-21.7 1.4-46.1-15.6-63.1-17-17-41.5-22.3-63.2-15.6l-19 5.8-9.3-17.5C301 61.6 280.1 48 256 48 231.9 48 210.9 61.6 200.3 81.6l-9.3 17.5-19-5.8c-21.7-6.7-46.1-1.4-63.1 15.6S86.6 150.4 93.3 172l5.8 19-17.5 9.3C61.6 210.9 48 231.9 48 256zm102.1 20.2l34.5-33.3c9.5 9.8 23.9 24.7 43.2 44.7l85.6-117.7 14.1-19.4 38.8 28.2-14.1 19.4-102.4 140.8-16.8 23.1c-8.8-9.1-30.9-32-66.2-68.6l-16.7-17.3z', 'M256 0c35.9 0 67.7 17.1 88 43.5 33-4.4 67.6 6 93.1 31.5s35.8 60 31.4 93C494.9 188.2 512 220 512 256s-17.2 67.7-43.6 88c4.4 33-6 67.6-31.4 93.1S377 472.8 344 468.4c-20.2 26.4-52 43.6-88 43.6s-67.8-17.1-88-43.6c-33 4.3-67.6-6-93-31.4S39.1 377 43.5 344C19.1 325.2 2.6 296.6 .3 263.9L0 256c0-35.9 17.1-67.8 43.5-88-4.3-33 6.1-67.6 31.5-93s60-35.8 93-31.5C188.2 17.1 220.1 0 256 0zm0 48c-24.1 0-45.1 13.6-55.7 33.6l-9.3 17.5-19-5.8c-21.7-6.7-46.1-1.4-63.1 15.6S86.6 150.4 93.3 172l5.8 19-17.5 9.3C61.6 210.9 48 231.9 48 256l.2 4.5c1.6 22.2 14.7 41.2 33.4 51.2l17.5 9.3-5.8 19c-6.7 21.7-1.4 46.1 15.6 63.2 17 17 41.4 22.3 63.1 15.6l19-5.8 9.3 17.6c10.6 20 31.6 33.6 55.7 33.6 24.1 0 45-13.5 55.7-33.6l9.3-17.6 19 5.8c21.7 6.7 46.1 1.4 63.2-15.6s22.3-41.5 15.6-63.2l-5.8-19 17.6-9.3c20-10.6 33.6-31.6 33.6-55.7 0-24.1-13.6-45.1-33.6-55.7l-17.6-9.3 5.8-19c6.7-21.7 1.4-46.1-15.6-63.1-17-17-41.5-22.3-63.2-15.6l-19 5.8-9.3-17.5C301 61.6 280.1 48 256 48zM366.3 178.7L352.2 198.1 249.8 338.9 233 362c-8.8-9.1-30.9-32-66.2-68.6l-16.7-17.3 34.5-33.3c9.5 9.8 23.9 24.7 43.2 44.7l85.6-117.7 14.1-19.4 38.8 28.2z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBadgeCheck = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;